import {
  Bar,
  mixins
} from "vue-chartjs";

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['measurement', 'showInLabel'],
  data: function() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        minBarLength: 2,
        scales: {
          xAxes: [{
            type: "time",
            distribution: 'series',
            display: true,
            offset: true,
            time: {
              unit: 'day',
              displayFormats: {
                hour: "DD MMM YYYY"
              },
              tooltipFormat: "DD MMM YYYY., HH:mm"
            },
            scaleLabel: {
              display: true,
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: "Precipitation (mm)"
            },
            ticks: {
              min: 0,
              callback: function(value) {
                return value + " mm";
              }
            },
            display: true
          }]
        },
        tooltips: {
          mode: 'index',
          callbacks: {
            label: function(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              label += tooltipItem.yLabel.toFixed(1);
              return label;
            }
          },
        },
        hover: {
          intersect: false
        },
      }
    }
  },
  mounted() {
    let UMeasure = ' mm'
    let yLabel = 'Precipitation (mm)'
    if (this.measurement == 'temperature') {
      UMeasure = ' °C'
      yLabel = 'Temperature (°C)'
    }
    this.options.scales.yAxes[0].ticks = {
      callback: function(value) {
        return value + UMeasure;
      }
    }
    this.options.scales.yAxes[0].scaleLabel.labelString = yLabel
    if(this.showInLabel == 'day'){
      this.options.scales.xAxes[0].time.displayFormats.hour = "DD MMM"
      this.options.scales.xAxes[0].time.tooltipFormat = "DD MMM"
    } else if(this.showInLabel == 'month'){
      this.options.scales.xAxes[0].time.displayFormats.day = "MMM"
      this.options.scales.xAxes[0].time.tooltipFormat = "MMM"
    } else {
      this.options.scales.xAxes[0].time.displayFormats.hour = "DD MMM YYYY"
      this.options.scales.xAxes[0].time.tooltipFormat = "DD MMM. YYYY, HH:mm"
    }
    this.renderChart(this.chartData, this.options);
  }
};
